/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { MapComponent } from './components/map.component';
import { StreetViewPanoComponent } from './components/street-view-pano.component';
import { MapTipDirective } from './components/map-tip.directive';
import { MapContainerComponent } from './components/map-container.component';
import { MapToolbarModule } from './toolbar/map-toolbar.module';
import { MapLegendModule } from './legend/map-legend.module';
import { NgxsModule } from '@ngxs/store';
import { ReloadDummyComponent } from './components/reload-dummy.component';
import { SharedModule } from '../shared/shared.module';
import { UiModule } from '../../core/ui/ui.module';
import { MapCommandModule } from './command/map-command.module';
import { MapContextMenuModule } from './context-menu/map-context-menu.module';

@NgModule({
    declarations: [
        MapComponent,
        MapContainerComponent,
        StreetViewPanoComponent,
        MapTipDirective,
        ReloadDummyComponent
    ],
    imports: [
        SharedModule,
        MapCommandModule,
        MapToolbarModule,
        MapContextMenuModule,
        MapLegendModule,
        NgxsModule,
        UiModule
    ]
})
export class MapModule {}
